/* global intercom */

export const logoutUser = () => {
	return (dispatch) => {
		// Log out Intercom
		window.localStorage.removeItem('MoonSignApp:intercom')
		if (process.env.REACT_APP_ENV === 'ios' || process.env.REACT_APP_ENV === 'android') {
			intercom.reset()
		}
		else {
			window.Intercom('shutdown')
		}
		// Log out
		window.localStorage.removeItem('MoonSignApp:login')
		window.history.pushState('', '', '/')
		window.location.reload()
	}
}



// WEBPACK FOOTER //
// ./src/redux/auth.js